module.exports = __webpack_public_path__ + "static/img/m_center_ed.1e443fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_center_ed.png
// module id = WhbV
// module chunks = 9